import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgDatePipe } from './shared/ngb-date.pipe';
import { NgDatePickerComponent } from './date-picker/date-picker.component';
import { NgDateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { NgDirectivesModule } from '../../../directives';
import { NgStylingComponentsModule } from '../../../styling-components';
import { NgDropdownsModule } from '../dropdowns/dropdowns.module';


@NgModule({
	declarations: [
		NgDatePipe,
		NgDatePickerComponent,
		NgDateRangePickerComponent
	],
	imports: [
		NgbDatepickerModule,
		FormsModule,
		NgDirectivesModule,
		NgStylingComponentsModule,
		NgDropdownsModule,
		CommonModule,
		ReactiveFormsModule
	],
	exports: [
		NgDatePickerComponent,
		NgDateRangePickerComponent
	]
})
export class NgDateInputsModule { }
